// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"565":"app-word","594":"about","881":"liexiaobao-word","952":"app-page","973":"agreement"}[chunkId] || chunkId) + "." + {"107":"c702251a","565":"02f6903f","594":"e5d3643c","881":"ed48b735","952":"836468b0","973":"3a825e29"}[chunkId] + ".js";
};